import React from "react";

/**
 * Horizontal category-filter chips (dark theme). Shows "Tutti (n)" plus one
 * chip per category in `categorie`, each with its own count from `articles`.
 */
export const CategoryFilters = ({ categorie, articles, current, onChange }) => {
  if (!categorie || categorie.length === 0) return null;

  const chipClass = (active) =>
    `mb-2 px-4 py-2 rounded-full text-sm font-semibold transition-all duration-200 border ${
      active
        ? "bg-pink-600 border-pink-600 text-white shadow-lg shadow-pink-600/25"
        : "bg-[#12121a] border-gray-700 text-gray-300 hover:border-pink-500/60 hover:text-white"
    }`;

  return (
    <div className="mb-8" data-testid="category-filters">
      <h3 className="text-lg font-extrabold uppercase text-white mb-4 flex items-center gap-2">
        <span className="inline-block w-8 h-[3px] bg-pink-500"></span> Filtra per Categoria
      </h3>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onChange("all")}
          className={chipClass(current === "all")}
          data-testid="category-filter-all"
        >
          Tutti ({articles.length})
        </button>
        {categorie.map((categoria) => (
          <button
            type="button"
            key={categoria}
            onClick={() => onChange(categoria)}
            className={chipClass(current === categoria)}
            data-testid={`category-filter-${categoria}`}
          >
            {categoria} ({articles.filter((a) => a.category === categoria).length})
          </button>
        ))}
      </div>
    </div>
  );
};
